import Styles from "./AdminVerticalmenu.module.scss";
import clsx from "clsx";
import { StoreHook, Actions } from "../../Store";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { NavLink } from "react-router-dom";
import { CiSignpostDuo1, CiAlignBottom } from "react-icons/ci";
import {
  OPENED,
  ISCLOSED,
  ADMIN_HISTORY,
  ADMIN_NEW,
  ADMIN_GUIDE,
  ADMIN_USERS,
  ADMIN_DASHBOARD,
  ADMIN_VOUCHER,
  ADMIN_VOUCHER_HISTORY,
  ADMIN_RATE_LIMIT,
  ADMIN_CHAT,
  ADMIN_ITEM_USAGE,
  ADMIN_TOP_UP,
} from "../../Store/Values";
import {
  adminHome,
  adminNews,
  adminUser,
  adminHistory,
  adminVoucherHistory,
  adminVoucher,
  adminRateLimit,
  adminChat,
  adminItemUsage,
  adminTopUp,
} from "../../Api/SubUrl";

function AdminVerticalmenu() {
  const [state, dispatch] = StoreHook();
  const { adminOpenOrCloseverticalMenu, adminActiveMenu } = state;

  const handleChosePage = (type) => {
    dispatch(
      Actions.updateAdminOpenOrCloseVerticalMenuChild(
        type !== ADMIN_GUIDE && type !== ADMIN_DASHBOARD ? OPENED : ISCLOSED
      )
    );
    dispatch(Actions.updateAdminActiveMenu(type));
  };

  return (
    <div
      className={clsx(
        Styles.main,
        adminOpenOrCloseverticalMenu ? Styles.active : "",
        "flex-grow-1"
      )}
    >
      <div className={clsx(Styles.mainWrap)}>
        <Navbar.Collapse
          className={clsx(Styles.menuWrap, " d-flex justify-content-end")}
          id="basic-navbar-nav"
        >
          <Nav className={clsx(Styles.menuHorizontal, "me-auto")}>
            <NavLink
              to={adminHome}
              onClick={() => handleChosePage(ADMIN_DASHBOARD)}
              className={clsx(
                Styles.itemNav,
                adminActiveMenu === ADMIN_DASHBOARD ? Styles.active : ""
              )}
            >
              <CiAlignBottom className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.itemContent)}>Thống Kê</span>
            </NavLink>
            <NavLink
              to={adminNews}
              onClick={() => handleChosePage(ADMIN_NEW)}
              className={clsx(
                Styles.itemNav,
                adminActiveMenu === ADMIN_NEW ? Styles.active : ""
              )}
            >
              <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.itemContent)}>Bảng Tin</span>
            </NavLink>
            <NavLink
              to={adminUser}
              onClick={() => handleChosePage(ADMIN_USERS)}
              className={clsx(
                Styles.itemNav,
                adminActiveMenu === ADMIN_USERS ? Styles.active : ""
              )}
            >
              <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.itemContent)}>Người dùng</span>
            </NavLink>
            <NavLink
              to={adminHistory}
              onClick={() => handleChosePage(ADMIN_HISTORY)}
              className={clsx(
                Styles.itemNav,
                adminActiveMenu === ADMIN_HISTORY ? Styles.active : ""
              )}
            >
              <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.itemContent)}>Lịch sử</span>
            </NavLink>
            
            <NavLink
              to={adminVoucher}
              onClick={() => handleChosePage(ADMIN_VOUCHER)}
              className={clsx(
                Styles.itemNav,
                adminActiveMenu === ADMIN_VOUCHER ? Styles.active : ""
              )}
            >
              <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.itemContent)}>Khuyến mãi</span>
            </NavLink>
            <NavLink
              to={adminVoucherHistory}
              onClick={() => handleChosePage(ADMIN_VOUCHER_HISTORY)}
              className={clsx(
                Styles.itemNav,
                adminActiveMenu === ADMIN_VOUCHER_HISTORY ? Styles.active : ""
              )}
            >
              <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.itemContent)}>
                Lịch sử khuyến mãi
              </span>
            </NavLink>
            <NavLink
              to={adminRateLimit}
              onClick={() => handleChosePage(ADMIN_RATE_LIMIT)}
              className={clsx(
                Styles.itemNav,
                adminActiveMenu === ADMIN_RATE_LIMIT ? Styles.active : ""
              )}
            >
              <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.itemContent)}>
                Tài khoản bị khóa
              </span>
            </NavLink>
            <NavLink
              to={adminChat}
              onClick={() => handleChosePage(ADMIN_CHAT)}
              className={clsx(
                Styles.itemNav,
                adminActiveMenu === ADMIN_CHAT ? Styles.active : ""
              )}
            >
              <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.itemContent)}>
                Quản lý trò chuyện
              </span>
            </NavLink>
            <NavLink
              to={adminItemUsage}
              onClick={() => handleChosePage(ADMIN_ITEM_USAGE)}
              className={clsx(
                Styles.itemNav,
                adminActiveMenu === ADMIN_ITEM_USAGE ? Styles.active : ""
              )}
            >
              <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.itemContent)}>
                Ghi nhận vật phẩm
              </span>
            </NavLink>
            <NavLink
              to={adminTopUp}
              onClick={() => handleChosePage(ADMIN_TOP_UP)}
              className={clsx(
                Styles.itemNav,
                adminActiveMenu === ADMIN_TOP_UP ? Styles.active : ""
              )}
            >
              <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
              <span className={clsx(Styles.itemContent)}>Ghi nhận thẻ nạp</span>
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </div>
    </div>
  );
}

export default AdminVerticalmenu;
